<template>
  <div class="wrap">
    <el-row>
      <el-col :span="8">
        <Logo />
      </el-col>
      <el-col :span="16" style="text-align: right;">
        <Navigation />
      </el-col>
    </el-row>
    <div class="main">
      <el-row>
        <el-col :span="14">
          <div class="main-img">
            <img :src="bigImg" >
          </div>
          <div class="sub-img">
            <div class="sub-item" v-for="(item, index) in dataList" :key="index" @click="handleChange(item)">
              <img :src="item.img" alt="">
              <div>{{item.text}}</div>
            </div>
          </div>
        </el-col>
        <el-col :span="10">
          <div class="img-text">
           {{introduce}}
          </div>
          <div class="company-info">
            <div><i class="el-icon-message"></i>:admin@garmentgc.com</div>
            <div><i class="el-icon-map-location"></i>:4/F,Shuangdeng building,No.109,zhuangpai Road,Jiangning District,Nanjing City,Jiangsu Province</div>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import Logo from '@/components/logo'
import Navigation from '@/components/navigation'
export default {
  name: 'Homepage',
  components: {Logo, Navigation},
  data () {
    return {
      bigImg: require('../../assets/da1.png'),
      introduce: `Nanjing ZEGUAN Garment Co.,Ltd.,established in 2008, is a rapidly
          developing manufacturer focusing onthe international garment and fabricgarment market.The company hasmore than 150 employees.The
          company is committed to producingand selling medium and high-gradeprofessional clothes, maternity
          clothes, etc.`,
      dataList: [
        {
          img: require('../../assets/da1.png'),
          text: 'Company',
          desc: `Company ZEGUAN Garment Co.,Ltd.,established in 2008, is a rapidly
          developing manufacturer focusing onthe international garment and fabricgarment market.The company hasmore than 150 employees.The
          company is committed to producingand selling medium and high-gradeprofessional clothes, maternity
          clothes, etc.`
        },
        {
          img: require('../../assets/da2.png'),
          text: 'Brand',
          desc: `Brand ZEGUAN Garment Co.,Ltd.,established in 2008, is a rapidly
          developing manufacturer focusing onthe international garment and fabricgarment market.The company hasmore than 150 employees.The
          company is committed to producingand selling medium and high-gradeprofessional clothes, maternity
          clothes, etc.`
        },
        {
          img: require('../../assets/da3.png'),
          text: 'Garment',
          desc: `Garment ZEGUAN Garment Co.,Ltd.,established in 2008, is a rapidly
          developing manufacturer focusing onthe international garment and fabricgarment market.The company hasmore than 150 employees.The
          company is committed to producingand selling medium and high-gradeprofessional clothes, maternity
          clothes, etc.`
        },
        {
          img: require('../../assets/da4.png'),
          text: 'Fabric',
          desc: `Fabric ZEGUAN Garment Co.,Ltd.,established in 2008, is a rapidly
          developing manufacturer focusing onthe international garment and fabricgarment market.The company hasmore than 150 employees.The
          company is committed to producingand selling medium and high-gradeprofessional clothes, maternity
          clothes, etc.`
        }
      ]
    }
  },
  methods: {
    handleChange (item) {
      this.bigImg = item.img
      this.introduce = item.desc
    }
  }
}
</script>

<style scoped>
.wrap {
  width: 1300px;
  margin: 0 auto;
}
.main {
  margin-top: 20px;
}
.main-img img {
  width: 720px;
  height: 458px;
  margin-bottom: 10px;
}
.sub-img {
  width: 720px;
  overflow: hidden;
  white-space: nowrap;
}
.sub-img img {
  width: 174px;
  height: 110px;
}
.sub-item {
  display: inline-block;
  margin-right: 8px;
  text-align: center;
}
.img-text {
  font-size: 28px;
  height: 458px;
  margin-bottom: 10px;
}
.company-info {
  border-top: 1px solid #000000;
  padding-top: 20px;
  font-size: 18px;
}
.company-info div {
  margin-bottom: 10px;
}
.company-info i {
  font-size: 20px;
  font-weight: 700;
}
</style>



// WEBPACK FOOTER //
// src/views/homepage/index.vue